export const LOCALIZED_COUNTRIES: Readonly<{ [key: string]: string }> = Object.freeze({
    af: '‫افغانستان‬‎',
    al: 'Shqipëri',
    dz: '‫الجزائر‬‎',
    am: 'Հայաստան',
    at: 'Österreich',
    az: 'Azərbaycan',
    bh: '‫البحرين‬‎',
    bd: 'বাংলাদেশ',
    by: 'Беларусь',
    be: 'België',
    bj: 'Bénin',
    bt: 'འབྲུག',
    ba: 'Босна и Херцеговина',
    br: 'Brasil',
    bg: 'България',
    bi: 'Uburundi',
    kh: 'កម្ពុជា',
    cm: 'Cameroun',
    cv: 'Kabu Verdi',
    cf: 'République centrafricaine',
    td: 'Tchad',
    cn: '中国',
    km: '‫جزر القمر‬‎',
    cd: '(DRC) (Jamhuri ya Kidemokrasia ya Kongo',
    cg: '(Republic) (Congo-Brazzaville)',
    ci: 'Côte d’Ivoire',
    hr: 'Hrvatska',
    cy: 'Κύπρος',
    cz: 'Česká republika',
    dk: 'Danmark',
    do: 'República Dominicana',
    eg: '‫مصر‬‎',
    gq: 'Guinea Ecuatorial',
    ee: 'Eesti',
    fo: 'Føroyar',
    fi: 'Suomi',
    gf: 'Guyane française',
    pf: 'Polynésie française',
    ge: 'საქართველო',
    de: 'Deutschland',
    gh: 'Gaana',
    gr: 'Ελλάδα',
    gl: 'Kalaallit Nunaat',
    gn: 'Guinée',
    gw: 'Guiné Bissau',
    hk: '香港',
    hu: 'Magyarország',
    is: 'Ísland',
    in: 'भारत',
    ir: '‫ایران‬‎',
    iq: '‫العراق‬‎',
    il: '‫ישראל‬‎',
    it: 'Italia',
    jp: '日本',
    jo: '‫الأردن‬‎',
    kz: 'Казахстан',
    kw: '‫الكويت‬‎',
    kg: 'Кыргызстан',
    la: 'ລາວ',
    lv: 'Latvija',
    lb: '‫لبنان‬‎',
    ly: '‫ليبيا‬‎',
    lt: 'Lietuva',
    mo: '澳門',
    mk: 'FYROM) (Македонија',
    mg: 'Madagasikara',
    mr: '‫موريتانيا‬‎',
    mu: 'Moris',
    mx: 'México',
    md: 'Republica Moldova',
    mn: 'Монгол',
    me: 'Crna Gora',
    ma: '‫المغرب‬‎',
    mz: 'Moçambique',
    mm: 'Burma) (မြန်မာ',
    na: 'Namibië',
    np: 'नेपाल',
    nl: 'Nederland',
    nc: 'Nouvelle-Calédonie',
    ne: 'Nijar',
    kp: '조선 민주주의 인민 공화국',
    no: 'Norge',
    om: '‫عُمان‬‎',
    pk: '‫پاکستان‬‎',
    ps: '‫فلسطين‬‎',
    pa: 'Panamá',
    pe: 'Perú',
    pl: 'Polska',
    qa: '‫قطر‬‎',
    re: 'La Réunion',
    ro: 'România',
    ru: 'Россия',
    pm: 'Saint-Pierre-et-Miquelon',
    st: 'São Tomé e Príncipe',
    sa: '‫المملكة العربية السعودية‬‎',
    sn: 'Sénégal',
    rs: 'Србија',
    sk: 'Slovensko',
    si: 'Slovenija',
    so: 'Soomaaliya',
    kr: '대한민국',
    ss: '‫جنوب السودان‬‎',
    es: 'España',
    lk: 'ශ්‍රී ලංකාව',
    sd: '‫السودان‬‎',
    se: 'Sverige',
    ch: 'Schweiz',
    sy: '‫سوريا‬‎',
    tw: '台灣',
    th: 'ไทย',
    tn: '‫تونس‬‎',
    tr: 'Türkiye',
    ua: 'Україна',
    ae: '‫الإمارات العربية المتحدة‬‎',
    uz: 'Oʻzbekiston',
    va: 'Città del Vaticano',
    vn: 'Việt Nam',
    wf: 'Wallis-et-Futuna',
    ye: '‫اليمن‬‎'
});
